@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
} @else {
  <form
    [formGroup]="defectFormGroup"
    [ngClass]="{
      disabled: formCheck(),
      complete: defectFormGroup.get('statusId').value === 3,
    }"
  >
    <mat-expansion-panel
      togglePosition="before"
      [expanded]="true"
      class="defect-expansion-panel"
    >
      <mat-expansion-panel-header class="header-styling">
        <mat-panel-title class="header">
          <div class="defect-header">
            {{ defectTitle }} - {{ locationSelection }}
          </div>
          <div class="defect-button-container">
            <div class="fixed-icon">
              <button
                type="button"
                (click)="fixDefect(defectFormGroup.value)"
                [disabled]="formCheck() || defectFormGroup.invalid"
                class="fix-defect-btn"
              >
                @if (defectFormGroup.get('statusId').value === 3) {
                  {{ fixedText }}<mat-icon>check_circle</mat-icon>
                } @else if (formCheck()) {
                  {{ sentToStationText
                  }}{{ defectFormGroup.get('stationName').value }}
                } @else {
                  {{ fixedText }}<mat-icon>check_circle_outlined</mat-icon>
                }
              </button>
            </div>
            @if (defectLengthCheck(element)) {
              @if (closedDefect()) {
                <button
                  type="button"
                  (click)="removeDefect(defectFormGroup.value)"
                  class="remove-defect-btn"
                >
                  <mat-icon>close</mat-icon>
                </button>
              }
            }
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div style="display: flex; justify-content: space-between">
        <div class="child-container">
          <div class="quantity">
            <dropdown-component
              [dropdownType]="'location'"
              [locations]="locations"
              [defectId]="defectFormGroup.get('defectId').value"
              (locationSelected)="onLocationChange($event)"
            ></dropdown-component>
          </div>
          <div class="quantity">
            <div class="label-text" style="font-weight: bold">{{ quantityLabel }}</div>
            <mat-form-field class="quantity-input" appearance="fill">
              <input
                matInput
                type="number"
                min="0"
                id="quantity"
                (keyup)="
                  changeQuantity(
                    defectFormGroup.get('quantity').value,
                    'custom'
                  )
                "
                formControlName="quantity"
              />
            </mat-form-field>
            <div class="quantity-btn-container">
              <button
                class="quantity-btns"
                [disabled]="
                  formCheck() || defectFormGroup.get('statusId').value === 3
                "
                (click)="
                  changeQuantity(defectFormGroup.get('quantity').value, 'add')
                "
              >
                <mat-icon style="color: var(--dep-text);">arrow_drop_up</mat-icon>
              </button>
              <button
                class="quantity-btns"
                [disabled]="
                  formCheck() || defectFormGroup.get('statusId').value === 3
                "
                (click)="
                  changeQuantity(
                    defectFormGroup.get('quantity').value,
                    'subtract'
                  )
                "
              >
                <mat-icon style="color: var(--dep-text);">arrow_drop_down</mat-icon>
              </button>
            </div>
          </div>
          <div class="quantity">
            <span class="comment-label label-text">{{ defectDescLabel }}</span>
            <textarea
              class="comment-text-area"
              (input)="addDefectDesc($event)"
              formControlName="defectDesc"
            ></textarea>
          </div>
          <div>
            <span class="comment-label label-text">{{ attachPhotosLabel }}</span>
            <button
              class="attach-photo-button"
              (click)="attachPhoto()"
              [disabled]="
                formCheck() || defectFormGroup.get('statusId').value === 3
              "
            >
              @if (photosAttachedCheck()) {
                <div
                  matBadge="{{ attachmentCount }}"
                  matBadgeOverlap="true"
                  matBadgeColor="warn"
                >
                  <mat-icon
                    [ngClass]="{
                      'photo-disabled':
                        formCheck() ||
                        defectFormGroup.get('statusId').value === 3,
                    }"
                    class="photo-enabled"
                    >add_a_photo</mat-icon
                  >
                </div>
              } @else {
                <mat-icon [ngClass]="{'photo-disabled': formCheck() || defectFormGroup.get('statusId').value === 3}" 
                class="photo-start">add_a_photo</mat-icon>
              }
            </button>
          </div>
        </div>
        <div class="child-container">
          @if (closedDefect()) {
            <designate-station
              [isEnabled]="enableDesignation"
              [designate]="defectFormGroup.get('designateStation').value"
              (designationTriggered)="onDesignationTriggered($event)"
            ></designate-station>
          } @else {
            <div class="designation-placeholder"></div>
          }
          <!-- Will remove after later release the travels images -->
          <div class="attached-note">{{ imageNote }}</div>
        </div>
      </div>
    </mat-expansion-panel>
  </form>
}
